import type { SVGProps } from 'react'

export const EnglishFlag = ({ className, ...svgProps }: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 16" className={className} {...svgProps}>
      {/* Blue background */}
      <rect width="24" height="16" fill="#012169" />

      {/* White diagonal cross (St. Andrew's cross) */}
      <path d="M0,0 L24,16 M24,0 L0,16" stroke="#ffffff" strokeWidth="2.67" />

      {/* Red diagonal cross (St. Patrick's cross) */}
      <path d="M0,0 L24,16 M24,0 L0,16" stroke="#C8102E" strokeWidth="1.33" />

      {/* White vertical and horizontal cross (St. George's cross) */}
      <rect x="10" y="0" width="4" height="16" fill="#ffffff" />
      <rect x="0" y="6" width="24" height="4" fill="#ffffff" />

      {/* Red vertical and horizontal cross (St. George's cross) */}
      <rect x="10.67" y="0" width="2.67" height="16" fill="#C8102E" />
      <rect x="0" y="6.67" width="24" height="2.67" fill="#C8102E" />
    </svg>
  )
}
